//artist actions
export const GET_FEATURED_ARTISTS = 'GET_FEATURED_ARTISTS';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_STATUS = 'GET_PROFILE_STATUS';
export const UPDATE_ROLE_RATING = 'UPDATE_ROLE_RATING';
export const GET_PROFILE_BIO = 'GET_PROFILE_BIO';
export const GET_PROFILE_BIO_STATUS = 'GET_PROFILE_BIO_STATUS';
export const GET_PROFILE_MUSIC = 'GET_PROFILE_MUSIC';
export const GET_PROFILE_MUSIC_STATUS = 'GET_PROFILE_MUSIC_STATUS';
export const GET_PROFILE_VIDEOS = 'GET_PROFILE_VIDEOS';
export const GET_PROFILE_VIDEOS_STATUS = 'GET_PROFILE_VIDEOS_STATUS';
export const GET_PROFILE_GIGS = 'GET_PROFILE_GIGS';
export const GET_PROFILE_GIGS_STATUS = 'GET_PROFILE_GIGS_STATUS';
export const GET_PROFILE_BUYOPTIONS = 'GET_PROFILE_BUYOPTIONS';
export const GET_PROFILE_BUYOPTIONS_STATUS = 'GET_PROFILE_BUYOPTIONS_STATUS';
export const GET_PROFILE_ADDRESS = 'GET_PROFILE_ADDRESS';
export const GET_PROFILE_ADDRESS_STATUS = 'GET_PROFILE_ADDRESS_STATUS';
export const GET_PROFILE_COMMENTS = 'GET_PROFILE_COMMENTS';
export const GET_PROFILE_COMMENTS_STATUS = 'GET_PROFILE_COMMENTS_STATUS';
export const GET_PROFILE_CONVERSATION = 'GET_PROFILE_CONVERSATION';
export const GET_PROFILE_CONVERSATION_STATUS = 'GET_PROFILE_CONVERSATION_STATUS';
export const GET_PROFILE_CONNECTIONS_INBOUND = 'GET_PROFILE_CONNECTIONS_INBOUND';
export const GET_PROFILE_CONNECTIONS_INBOUND_STATUS = 'GET_PROFILE_CONNECTIONS_INBOUND_STATUS';
export const GET_PROFILE_CONNECTIONS_OUTBOUND = 'GET_PROFILE_CONNECTIONS_OUTBOUND';
export const GET_PROFILE_CONNECTIONS_OUTBOUND_STATUS = 'GET_PROFILE_CONNECTIONS_OUTBOUND_STATUS';
export const ADD_CONNECTION = 'ADD_CONNECTION';
export const DELETE_CONNECTION = 'DELETE_CONNECTION';

//artist browse actions
export const SET_PROFILE_BROWSE_ROLETYPE = 'SET_PROFILE_BROWSE_ROLETYPE';
export const CLEAR_PROFILE_SEARCH_CRITERIA = 'CLEAR_PROFILE_SEARCH_CRITERIA';
export const SET_PROFILE_BROWSE_RESULTS = 'SET_PROFILE_BROWSE_RESULTS';
export const CLEAR_PROFILE_BROWSE_RESULTS = 'CLEAR_PROFILE_BROWSE_RESULTS';
export const SET_PROFILE_SEARCH_ERROR = 'SET_PROFILE_SEARCH_ERROR';
export const CLEAR_PROFILE_SEARCH_ERROR = 'CLEAR_PROFILE_SEARCH_ERROR';
export const SET_PROFILE_BROWSE_ERROR = 'SET_PROFILE_BROWSE_ERROR';
export const CLEAR_PROFILE_BROWSE_ERROR = 'CLEAR_PROFILE_BROWSE_ERROR';
export const SET_PROFILE_BROWSE_TAB = 'SET_PROFILE_BROWSE_TAB';
export const SET_PROFILE_KEYWORD = 'SET_PROFILE_KEYWORD';
export const CLEAR_PROFILE_KEYWORD = 'CLEAR_PROFILE_KEYWORD';
export const BROWSE_PROFILES_STATUS = 'BROWSE_PROFILES_STATUS';
export const SET_PROFILE_BROWSE_SORT = 'SET_PROFILE_BROWSE_SORT';
export const SET_PROFILE_BROWSE_CAPACITY = 'SET_PROFILE_BROWSE_CAPACITY';
export const SET_PROFILE_BROWSE_ADD_GENRE = 'SET_PROFILE_BROWSE_ADD_GENRE';
export const SET_PROFILE_BROWSE_REMOVE_GENRE = 'SET_PROFILE_BROWSE_REMOVE_GENRE';
export const SET_PROFILE_BROWSE_CLEAR_GENRES = 'SET_PROFILE_BROWSE_CLEAR_GENRES';
export const SET_PROFILE_BROWSE_ASSOCIATIONS = 'SET_PROFILE_BROWSE_ASSOCIATIONS';
export const SET_PROFILE_BROWSE_DISTANCE = 'SET_PROFILE_BROWSE_DISTANCE';
export const SET_PROFILE_BROWSE_DISTANCE_UNIT = 'SET_PROFILE_BROWSE_DISTANCE_UNIT';
export const SET_PROFILE_BROWSE_LOCATION = 'SET_PROFILE_BROWSE_LOCATION';
export const SET_PROFILE_BROWSE_INSTRUMENT = 'SET_PROFILE_BROWSE_INSTRUMENT';
export const SET_PROFILE_BROWSE_EXPERTISE = 'SET_PROFILE_BROWSE_EXPERTISE';

//artist admin actions
export const SET_CREATE_PROFILE_ERROR = 'SET_CREATE_PROFILE_ERROR';
export const CLEAR_CREATE_PROFILE_ERROR = 'CLEAR_CREATE_PROFILE_ERROR';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const PROFILE_IMAGES_UPDATED = 'PROFILE_IMAGES_UPDATED';
export const CLEAR_PROFILE_TRACKS = 'CLEAR_PROFILE_TRACKS';
export const CLEAR_PROFILE_VIDEOS = 'CLEAR_PROFILE_VIDEOS';
export const CLEAR_PROFILE_GIGS = 'CLEAR_PROFILE_GIGS';
export const CLEAR_PROFILE_BUY_OPTIONS = 'CLEAR_PROFILE_BUY_OPTIONS';
export const CLEAR_PROFILE_ADDRESS = 'CLEAR_PROFILE_ADDRESS';

//track actions
export const GET_FEATURED_TRACKS = 'GET_FEATURED_TRACKS';
export const GET_TRACK = 'GET_TRACK';
export const GET_MUSIC_CHARTS = 'GET_MUSIC_CHARTS';
export const GET_MUSIC_CHARTS_STATUS = 'GET_MUSIC_CHARTS_STATUS';
export const PLAY_TRACK = 'PLAY_TRACK';
export const SET_TRACK_STATUS = 'SET_TRACK_STATUS';
export const UPDATE_TRACK_RATING = 'UPDATE_TRACK_RATING';
export const TRACK_CHANGED = 'TRACK_CHANGED';

//video actions
export const GET_VIDEO = 'GET_VIDEO';
export const GET_VIDEO_CHARTS = 'GET_VIDEO_CHARTS';
export const GET_VIDEO_CHARTS_STATUS = 'GET_VIDEO_CHARTS_STATUS';
export const PLAY_VIDEO = 'PLAY_VIDEO';
export const UPDATE_VIDEO_RATING = 'UPDATE_VIDEO_RATING';

//account actions
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const CLEAR_USER_LOADING = 'CLEAR_USER_LOADING';
export const LOGOUT = 'LOGOUT';
export const UPDATE_ACTIVE_PROFILE = 'UPDATE_ACTIVE_PROFILE';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';
export const SET_SIGNUP_ERROR = 'SET_SIGNUP_ERROR';
export const CLEAR_SIGNUP_ERROR = 'CLEAR_SIGNUP_ERROR';
export const CONFIRM_EMAIL = 'CONFIRM_EMAIL';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SOUNDCLOUD_LOGIN_SUCCESS = 'SOUNDCLOUD_LOGIN_SUCCESS';
export const GET_NOTIFICATION_COUNT = 'GET_NOTIFICATION_COUNT';

//gig actions
export const GET_GIG = 'GET_GIG';
export const GET_GIG_STATUS = 'GET_GIG_STATUS';
export const SET_GIG_BROWSE_DATES = 'SET_GIG_BROWSE_DATES';

//gig browse actions
export const CLEAR_GIG_SEARCH_CRITERIA = 'CLEAR_GIG_SEARCH_CRITERIA';
export const SET_GIG_BROWSE_RESULTS = 'SET_GIG_BROWSE_RESULTS';
export const CLEAR_GIG_BROWSE_RESULTS = 'CLEAR_GIG_BROWSE_RESULTS';
export const SET_GIG_SEARCH_ERROR = 'SET_GIG_SEARCH_ERROR';
export const CLEAR_GIG_SEARCH_ERROR = 'CLEAR_GIG_SEARCH_ERROR';
export const SET_GIG_BROWSE_ERROR = 'SET_GIG_BROWSE_ERROR';
export const CLEAR_GIG_BROWSE_ERROR = 'CLEAR_GIG_BROWSE_ERROR';
export const SET_GIG_BROWSE_TAB = 'SET_GIG_BROWSE_TAB';
export const SET_GIG_KEYWORD = 'SET_GIG_KEYWORD';
export const CLEAR_GIG_KEYWORD = 'CLEAR_GIG_KEYWORD';
export const BROWSE_GIG_STATUS = 'BROWSE_GIG_STATUS';
export const SET_GIG_BROWSE_SORT = 'SET_GIG_BROWSE_SORT';
export const SET_GIG_BROWSE_ADD_GENRE = 'SET_GIG_BROWSE_ADD_GENRE';
export const SET_GIG_BROWSE_REMOVE_GENRE = 'SET_GIG_BROWSE_REMOVE_GENRE';
export const SET_GIG_BROWSE_DISTANCE = 'SET_GIG_BROWSE_DISTANCE';
export const SET_GIG_BROWSE_DISTANCE_UNIT = 'SET_GIG_BROWSE_DISTANCE_UNIT';
export const SET_GIG_BROWSE_LOCATION = 'SET_GIG_BROWSE_LOCATION';
export const SET_GIG_BROWSE_START_DATE = 'SET_GIG_BROWSE_START_DATE';
export const SET_GIG_BROWSE_END_DATE = 'SET_GIG_BROWSE_END_DATE';

//genre actions
export const GET_GENRES = 'GET_GENRES';

//instrument actions
export const GET_INSTRUMENTS = 'GET_INSTRUMENTS';

//location actions
export const GET_COUNTRIES = 'GET_COUNTRIES';

//activity feed actions
export const GET_ACTIVITY_FEED = 'GET_ACTIVITY_FEED';
export const GET_ACTIVITY_FEED_STATUS = 'GET_ACTIVITY_FEED_STATUS';
export const CLEAR_ACTIVITY_FEED = 'CLEAR_ACTIVITY_FEED';

//blog actions
export const GET_BLOG_GENERAL = 'GET_BLOG_GENERAL';
export const GET_BLOG_UNSIGNED = 'GET_BLOG_UNSIGNED';
export const GET_BLOG_DISCOVER = 'GET_BLOG_DISCOVER';
export const CLEAR_BLOG_GENERAL = 'CLEAR_BLOG_GENERAL';
export const CLEAR_BLOG_UNSIGNED = 'CLEAR_BLOG_UNSIGNED';
export const CLEAR_BLOG_DISCOVER = 'CLEAR_BLOG_DISCOVER';
export const GET_BLOG_GENERAL_STATUS = 'GET_BLOG_GENERAL_STATUS';
export const GET_BLOG_UNSIGNED_STATUS = 'GET_BLOG_UNSIGNED_STATUS';
export const GET_BLOG_DISCOVER_STATUS = 'GET_BLOG_DISCOVER_STATUS';
export const GET_BLOG_SECTIONS_GENERAL = 'GET_BLOG_SECTIONS_GENERAL';
export const GET_BLOG_SECTIONS_UNSIGNED = 'GET_BLOG_SECTIONS_UNSIGNED';
export const GET_BLOG_SECTIONS_DISCOVER = 'GET_BLOG_SECTIONS_DISCOVER';
export const GET_BLOG_TAGS_GENERAL = 'GET_BLOG_TAGS_GENERAL';
export const GET_BLOG_TAGS_UNSIGNED = 'GET_BLOG_TAGS_UNSIGNED';
export const GET_BLOG_TAGS_DISCOVER = 'GET_BLOG_TAGS_DISCOVER';
export const GET_ARTICLE = 'GET_ARTICLE';
export const GET_ARTICLE_STATUS = 'GET_ARTICLE_STATUS';
export const GET_ARTICLE_SHARES = 'GET_ARTICLE_SHARES';

//discussion actions
export const GET_DISCUSSION_SECTIONS = 'GET_DISCUSSION_SECTIONS';
export const GET_DISCUSSIONS = 'GET_DISCUSSIONS';
export const CLEAR_DISCUSSIONS = 'CLEAR_DISCUSSIONS';
export const GET_POSTS = 'GET_POSTS';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const UPDATE_POST_REPORT = 'UPDATE_POST_REPORT';

//common actions
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';